import React, { useState, useEffect } from "react";
import Layout from "../components/layouts/Layout";
import { useParams } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { useCart } from "../context/cart";

const DetailPage = () => {
  const [product, setProduct] = useState({});
  const [cart, setCart] = useCart();
  const params = useParams();

  // Get Single Product
  const getSingleProduct = async () => {
    try {
      const { data } = await axios.get(
        `https://urbancart-ecommerce-store.onrender.com/api/v1/product/find-products/${params.slug}`
      );
      setProduct(data?.product);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load product details");
    }
  };

  useEffect(() => {
    getSingleProduct();
  }, []);

  return (
    <Layout title={product?.name}>
      <div className="container my-5">
        <div className="row">
          {/* Product Image */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <img
              src={`https://urbancart-ecommerce-store.onrender.com/api/v1/product/get-photo/${product._id}`}
              alt={product.name}
              className="img-fluid rounded shadow-sm"
              style={{
                objectFit: "contain",
                maxHeight: "320px",
                width: "100%",
                padding: "4px",
              }}
            />
          </div>
          {/* Product Details */}
          <div className="col-md-6">
            <h2 className="display-5">{product.name}</h2>
            <p className="lead text-muted">{product.description}</p>
            <h3 className="text-success">
              {product.price?.toLocaleString("en-US", {
                style: "currency",
                currency: "INR",
              })}
            </h3>
            <button
              className="btn btn-warning btn-lg text-white mt-4"
              onClick={() => {
                setCart([...cart, product]);
                localStorage.setItem(
                  "cart",
                  JSON.stringify([...cart, product])
                );
                toast.success("Item Added to cart");
              }}
            >
              Add to Cart
            </button>
            <button
              className="btn btn-outline-primary btn-lg mt-4 ms-3"
              onClick={() => window.history.back()}
            >
              Back to Products
            </button>
          </div>
        </div>

        {/* Additional Details */}
        <div className="row mt-5">
          <div className="col-12">
            <h4 className="mb-3">Product Specifications</h4>
            <ul className="list-group">
              <li className="list-group-item">
                <strong>Category:</strong> {product.category?.name}
              </li>
              <li className="list-group-item">
                <strong>Stock:</strong>{" "}
                {product.quantity > 0 ? "In Stock" : "Out of Stock"}
              </li>
              <li className="list-group-item">
                <strong>Delivery:</strong>{" "}
                {product.shipping ? "Available" : "Not Available"}
              </li>
              <li className="list-group-item">
                <strong>Rating:</strong> <span>4.7</span>
                <i class="fa-solid fa-star"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DetailPage;

// import React, { useState, useEffect } from "react";
// import Layout from "../components/layouts/Layout";
// import toast from "react-hot-toast";
// import { useParams } from "react-router-dom";
// import axios from "axios";

// const DetailPage = () => {
//   const [product, setProduct] = useState({});
//   const params = useParams();

//   // Fetch Single Product
//   const getSingleProduct = async () => {
//     try {
//       const { data } = await axios.get(`/api/v1/product/find-products/${params.slug}`);
//       if (data?.success) {
//         setProduct(data?.product);
//       } else {
//         toast.error("Unable to fetch product details");
//       }
//     } catch (error) {
//       console.error(error);
//       toast.error("Something went wrong");
//     }
//   };

//   useEffect(() => {
//     getSingleProduct();
//   }, [params.slug]);

//   return (
//     <Layout title={`${product?.name} - Urban Cart`}>
//       <div className="container my-5">
//         <div className="row d-flex justify-content-center align-items-center">
//           {/* Image Section */}
//           <div className="col-md-6 text-center">
//             <img
//               src={`/api/v1/product/get-photo/${product._id}`}
//               alt={product.name}
//               className="img-fluid rounded shadow"
//               style={{ maxHeight: "400px", objectFit: "contain" }}
//             />
//           </div>
//           {/* Product Details */}
//           <div className="col-md-6">
//             <h2 className="text-uppercase fw-bold mb-3">{product.name}</h2>
//             <p className="lead">{product.description}</p>
//             <h4 className="text-success fw-bold">
//               {product.price?.toLocaleString("en-US", {
//                 style: "currency",
//                 currency: "INR",
//               })}
//             </h4>
//             <div className="d-flex mt-4">
//               <button
//                 className="btn btn-warning text-white me-3"
//                 onClick={() => {
//                   // Handle add to cart logic here
//                   // For example:
//                   toast.success("Item added to cart");
//                 }}
//               >
//                 Add to Cart
//               </button>
//               <button
//                 className="btn btn-primary"
//                 onClick={() => window.history.back()}
//               >
//                 Go Back
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </Layout>
//   );
// };

// export default DetailPage;
